import { useEffect, useState } from 'react';
import css from './index.module.scss';
import A from './components/A';
import B from './components/B';
import C from './components/C';
import { useLang } from '@/i18n';

export const encodeBase64 = (str: string): string => {
    const uint8Array = new TextEncoder().encode(str);
    return Buffer.from(uint8Array).toString('base64');
};

export const decodeBase64 = (base64: string): string => {
    const uint8Array = Uint8Array.from(Buffer.from(base64, 'base64'));
    return new TextDecoder().decode(uint8Array);
};

const Recall = () => {
    const { t } = useLang('recall');
    const [canForm, setCanForm] = useState(false);
    const [snCode, setSnCode] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);

    const updateQueryParam = (key: string, value: string | null) => {
        const url = new URL(window.location.href);
        if (value === null) {
            url.searchParams.delete(key);
        } else {
            url.searchParams.set(key, encodeBase64(value));
        }
        window.history.replaceState(null, '', url.toString());
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const sn = urlParams.get('snCode');
        const success = urlParams.get('isSuccess');
        const can = urlParams.get('can');

        setSnCode(sn ? decodeBase64(sn) : '');
        setIsSuccess(decodeBase64(success ?? '') === 'true');
        setCanForm(decodeBase64(can ?? '') === 'true');
    }, []);
    return (
        <div className={`${css.page}`}>
            <h1 className="recall-page-title">{t('title')}</h1>
            {isSuccess ? (
                <C />
            ) : (
                <>
                    <A
                        callback={(snCode: string, can: boolean) => {
                            setSnCode(snCode);
                            setCanForm(can);
                            // 将 snCode 设置到 query 上原生
                            updateQueryParam('snCode', snCode);
                            updateQueryParam('can', String(can));
                        }}
                    />
                    {canForm && (
                        <B
                            snCode={snCode}
                            callback={(b) => {
                                setIsSuccess(b);
                                updateQueryParam('isSuccess', String(b));
                            }}
                        />
                    )}
                </>
            )}
        </div>
    );
};
export default Recall;
